import { faAngleDown as lightAngleDown } from "@jewlr/pro-light-svg-icons/faAngleDown"
import { faAngleUp as lightAngleUp } from "@jewlr/pro-light-svg-icons/faAngleUp"
import {
  Box,
  Flex,
  FontAwesomeIcon,
  MediaBox,
  MediaFlex,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import withFilters from "areas/collection/hoc/with-filters"
import SortFilter from "areas/collection/sort-filter"

import FilterMenu from "./filter-menu"

const HeaderContainer = styled(Box)`
  border-bottom: 1px solid ${(props) => props.theme.colors.grey10};
  padding: 10px 16px;
  position: relative;
  ${({ theme }) => theme.mediaQueries.desktop`
    padding: 20px 0;
  `}
`
const Container = styled(Flex).attrs({
  contain: true,
})`
  align-items: center;
  justify-content: space-between;
  ${({ theme }) => theme.mediaQueries.tablet`
    position: relative;
    line-height:1;
  `}
`
const FilterToggle = styled(Box)`
  align-items: center;
  cursor: pointer;
  display: flex;
  ${({ theme }) => theme.mediaQueries.desktop`
    line-height: 1.2;
    text-transform: uppercase;
  `}
`
const FilterArrow = styled(FontAwesomeIcon)`
  color: ${(props) => props.theme.colors.primary};
  margin-left: 5px;
  vertical-align: text-bottom;
`

const BoxDisplay = styled(MediaBox).attrs({
  greaterThanOrEqual: "desktop",
})``

const InternalFilterHeader = ({
  currentSort,
  disableFilters,
  disableSort,
  openedSort,
  toggleFilter,
  toggleSort,
}) => {
  return (
    <HeaderContainer>
      <Container>
        {!disableFilters ? (
          <BoxDisplay>
            <FilterMenu />
          </BoxDisplay>
        ) : (
          <BoxDisplay />
        )}
        {!disableFilters ? (
          <MediaFlex
            alignItems="center"
            fontSize="16px"
            lessThan="desktop"
            letterSpacing="1px"
            onClick={() => toggleFilter(true)}
          >
            <Box
              as="img"
              data-cy="collection-filter-icon-mobile"
              pr="5px"
              src={require("images/icons/filter_icon_blue.svg")}
              width="20"
            />
            Filter
          </MediaFlex>
        ) : (
          <Box />
        )}

        {!disableSort && (
          <FilterToggle
            data-cy="collection-sort-button"
            onClick={(e) => toggleSort(e, openedSort)}
          >
            <Box fontSize={{ _: "16px", tablet: "14px" }} lineHeight="2">
              Sort by:{" "}
              {currentSort && (
                <Box as="strong" color="primary" ml="5px">
                  {currentSort.label}
                </Box>
              )}
              <FilterArrow icon={openedSort ? lightAngleUp : lightAngleDown} />
              <SortFilter />
            </Box>
          </FilterToggle>
        )}
      </Container>
    </HeaderContainer>
  )
}

InternalFilterHeader.propTypes = {
  currentSort: PropTypes.shape({
    label: PropTypes.string,
  }),
  disableFilters: PropTypes.bool,
  disableSort: PropTypes.bool,
  openedSort: PropTypes.bool,
  toggleFilter: PropTypes.func,
  toggleSort: PropTypes.func,
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = () => {
  return {}
}

const FilterHeader = connect(
  mapStateToProps,
  mapDispatchToProps
)(withFilters(InternalFilterHeader))

export default FilterHeader
